import React from "react";
import PropTypes from "prop-types";
import * as ReactBootstrap from "react-bootstrap";
import UrlHelper from "../../utilities/UrlHelper";

const CompleteAccountSetup = ({ email, onComplete, completeButtonTitle, title, text }) => {
    const emailLoginUrl = UrlHelper.getEmailLoginUrl();

    return (
        <div className="completeAccountSetup">
            <div className="form-title long-title"><span className="ion-android-done"/><span className="title">{title}</span></div>

            <div className="linked-email">{email}</div>

            <div name="main-text" className="form-subtitle">
                {text}
            </div>

            <p>
                <div name="sub-text" className="form-subtitle">
                    <p>
                    Remember to bookmark the SoleSource Sign-in page: <a id="newLoginLink" href={emailLoginUrl}>{emailLoginUrl}</a>.
                    </p>
                </div>
            </p>
            <div className="button-container">
                <ReactBootstrap.Button className="btn btn-primary-action pull-right btn btn-default" onClick={onComplete}>
                    {completeButtonTitle}
                </ReactBootstrap.Button>
            </div>
        </div>
    );
};

CompleteAccountSetup.propTypes = {
    onComplete: PropTypes.func,
    completeButtonTitle: PropTypes.string,
    email: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string
};

export default CompleteAccountSetup;
